window.LaunchPage = Backbone.View.extend({

    initialize: function(properties) {
        this.isSelected = false;
        this.wrapper = properties.wrapper;
        this.tracking = properties.tracking;
        this.xmlPath = properties.xml;
        this.enableOnlyEnglish = (properties.enableOnlyEnglish !== undefined) ? properties.enableOnlyEnglish : false;

        this.loadXML();
        this.loadLanguage();
    },

    setup: function(xml) {
        this.data = this.getData($(xml));
        this.render();
    },

    loadLanguage: function() {
        this.language = this.tracking.getItem(LaunchPage.LANGUAGE_PREFERENCE_LABEL);
    },

    saveLanguage: function(language) {
        this.language = language;
        this.tracking.setItem(LaunchPage.LANGUAGE_PREFERENCE_LABEL, language);
    },

    loadXML: function() {
        var loader = new AssetLoader({
            name: "LaunchPage"
        });
        loader.addXML(this.xmlPath);
        this.listenToOnce(loader, "onAssetLoaded", function(e) {
            this.setup(e.resource.getXML());
        });

        loader.start();
    },

    render: function() {
        this.$content = $(this.getContent(this.data));
        this.$dom = $(this.wrapper).append(this.$content);
        this.$panel = this.$dom.find(".panel");
        this.$confirmButton = this.$dom.find(".confirm-button");
        this.$languageSelect = this.$dom.find("select[name=language]");

        this.setupButton();
        this.selectLanguage();

        this.animatePanelIn();
    },

    selectLanguage: function() {
        var languages = this.data.varients;
        var self = this;

        this.$languageSelect.change(function(e) {
            var selectedCode = $(this).find("option:selected").attr("value");
            var language = _.findWhere(languages, {
                code: selectedCode
            });
            
            self.updateConfirmButton(language);
        });
    },
    
    updateConfirmButton: function (language) {
        this.$confirmButton.text(language.buttonLabel).attr("id", language.code);
    },

    setupButton: function() {
        var confirmButton = new Button({
            el: this.$confirmButton
        });
        this.listenTo(confirmButton, "onClick", this.handleLanguageConfirm);
    },

    handleLanguageConfirm: function(e) {
        if (!this.isSelected) {
            this.isSelected = true;
            var $button = $(e.currentTarget);
            this.saveLanguage($button.attr("id"));
            this.animatePanelOut();
        }
    },

    animatePanelIn: function() {
        TweenMax.fromTo(this.$panel, 0.3, {
            y: 5,
            opacity: 0
        }, {
            display: "block",
            y: 0,
            opacity: 1,
            ease: Power4.easeOut,
            delay: 0.5
        });
    },

    animatePanelOut: function() {
        var self = this;
        TweenMax.to(this.$panel, 0.3, {
            y: 0,
            opacity: 0,
            ease: Power4.easeOut,
            onComplete: function() {
                self.trigger("onLaunchCourse", {
                    language: self.language
                });
                self.destroy();
            }
        });
    },

    getContent: function(data) {
        return Handlebars.templates["launch/launchpage"](data);
    },

    getData: function($xml) {
        var data = {
            varients: [],
            mainText: $xml.find("mainText").find("en").find("text").text()
        };
        _.each($xml.find("optionList").find("row:first").find("index"), function(item, i) {
            var $item = $(item);
            var varient = {
                id: i,
                code: $item.find("param1").find("en").find("text").text(),
                language: $item.find("param2").find("en").find("text").text(),
                buttonLabel: $item.find("param3").find("en").find("text").text()
            };
            
            data.varients.push(varient);
        });

        data.logo = $xml.find("optionList").find("row:last").find("index").find("param2").find("en").find("text").text();
        data.sublogo = $xml.find("item[key='subimage']").text();
        data.code = data.varients[0].code;
        data.button = data.varients[0].buttonLabel;
        data.projectTitle = $xml.find("optionList").find("row:last").find("index").find("param3").find("en").find("text").text();

        return data;
    },

    destroy: function() {
        _.each(this.languageButtons, function(button) {
            this.stopListening(button, "onClick");
        }, this);
        this.$content.remove();
    }

}, {
    LANGUAGE_PREFERENCE_LABEL: "language-selected",
});
